import React from 'react';

const IconCheckmark = ({ className, stroke = 'white', strokeWidth = '0.7' }) => {
    return (
        <svg className={className} viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.5 2.50012L3.5 5.50012L8.50024 0.5"
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeLinecap="butt"
                strokeLinejoin="miter"
            />
        </svg>
    );
};

export default IconCheckmark;

